export default "__VITE_ASSET__vIke788x__"